import { createSelector } from 'reselect';

const selectVideoPlayer = state => state.video_player;
const selectCurrentUser = state => (state.user || {}).current;
const selectVideo = createSelector(selectVideoPlayer, ({ video }) => video);
const selectUserId = createSelector(selectCurrentUser, ({ id }) => id);

export const selectEmbed = createSelector(
  selectUserId,
  selectVideoPlayer,
  selectVideo,
  (
    userId,
    { isMainVideoOnSharePage },
    {
      id: videoId,
      owner_id: ownerId,
      videoAnalyticsEnabled = false,
      current_user_is_owner: isOwner,
      processing_information: { trim_id: trimId = null } = {},
    }
  ) => {
    return {
      userId,
      trimId,
      videoId,
      ownerId,
      isOwner,
      videoAnalyticsEnabled,
      isMainVideoOnSharePage,
    };
  }
);
